module.exports = __webpack_public_path__ + "docs/dev-fund-0671c9.md";